export default {
    designerPage: {
        title: 'For Designers',
        designerInfo: {
        heading: 'For Designers',
        paragraphs: [
            'The use of absolutely any materials in finishing, such as stone slabs, glass, carbon, natural veneer, gold, genuine crocodile leather, and other exotic types… The limit of imagination simply does not exist!',
            'Collaborating with us can expand your possibilities and meet the demands of even the most discerning client. Partnership and mutually beneficial relationships with us will inspire you even further!',
        ],
        },
        diagrams: {
            floatingCabinet: 'Floating Cabinet and Panel Diagrams',
            frame: 'Frame Diagrams',
            liftingMechanism: 'Lifting Mechanism Diagrams',
        },
    },
    menuText: {
        buttons: {
            subscribeBtn: 'Subscribe',
            msgUs: 'Contact us'
        },
        links: {
            collection: 'COLLECTION',
            gallery: 'GALLERY',
            constructor: 'CONSTRUCTOR',
            designer: 'FOR DESIGNERS',
            info: 'INFO'
        }
    },
    footer: {
        phone: 'Phone: ',
        mail: 'Mail: '
    },
    infoPage: {
        title: 'Information',
        p1: {
            title1: 'About Us',
            text1: 'NIRIVS is a team of talented designers and architects specializing in the creation of exclusive and luxurious floating beds. We offer unique solutions for those who value comfort, style, and cutting-edge technology. NIRIVS is committed to continuous development and enhancement of our technologies. We stay updated on market innovations and implement the most advanced solutions so our clients can enjoy the most modern and comfortable floating beds.',
            text2: 'We take pride in the high cost of our products, as it underscores the exclusivity and quality of our creations. We value our work! Our floating beds are distinguished not only by their exquisite design but also by their unparalleled quality. The use of advanced materials and technologies ensures the durability and reliability of our constructions, along with unmatched comfort during sleep. Each project is developed individually for our clients, considering their preferences and interior features.',
            title2: 'Our mission',
            text3: 'To provide each client with a bed that will not only serve as a comfortable sleeping space but also become a true work of art in their home.'
        },
        phone: 'Phone: ',
        address: 'Address: Rostov-on-Don, Mikhail Nagibin ave., 30L, 2nd floor'
    },
    mainPage: {
        title: 'Main',
        img1: {
            desc1: 'Unparalleled worldwide',
            desc2: 'The most realistic vaporizing effect',
            desc3: 'Lifetime warranty on the design'
        },
        buttonsText1: 'Gallery',
        buttonsText2: 'Constructor',
        img2: {
            title: 'Exclusivity and Luxury',
            desc: 'NIRIVS specializes in crafting unique floating beds that boast luxurious designs created by professionals. This ensures clients not only enjoy a high level of comfort and style in their interiors but also highlights the exclusivity of their space.'
        },
        img3: {
            title: 'Personalized Approach',
            desc: "NIRIVS designs each bed individually, taking into account the client's preferences and the unique features of their interior. A wide selection of materials, colors, and finishes allows for the creation of a perfect combination that will harmoniously fit into the customer's home."
        },
        img4: {
            title: 'Cutting-Edge Technologies',
            desc: 'NIRIVS specializes in creating unique floating beds that boast luxurious designs crafted by professionals. This ensures that clients not only enjoy a high level of comfort and style in their interiors but also highlights the exclusivity of their spaces.'
        },
        img5: {
            title: 'Strong frame',
            p1: 'The frame of the NIRIVS floating bed is a proprietary design developed by our company and is protected by a patent for invention. The testing of the bed spanned several years, allowing us to thoroughly consider all technical nuances and user preferences.',
            p2: 'A distinctive feature of the frame is the presence of four diagonal stiffeners surrounding the central support, while the load-bearing structure, made from specially designed aluminum profiles, unifies the entire construction and is anchored to the floor with six anchor bolts. This solution offers limitless possibilities for design concepts, and notably, this bed can even be installed on a yacht!',
            p3: 'The components of the NIRIVS bed frame are crafted from aerospace-grade aluminum alloy, coated with a special finish that protects them from oxidation while simultaneously providing a modern and appealing aesthetic.The intricate configuration of the frame components, the material from which they are made, and the overall design confer the highest rigidity to the structure, thereby guaranteeing the elimination of any creaking during operation, which undoubtedly enhances its comfort. We offer a lifetime warranty on this construction! The weight of the structure, including the mattress base, is approximately 130 kg.'
        }
    },
    collectionPage: {
        title: 'Bed models',
        additionalText: 'Includes:',
        model1: {
            title: 'LOFT',
            features: [
                'Bed frame',
                'Wooden headboard',
                'Headboard lighting',
                '2 cabinets',
                'Storage space under the mattress',
            ],
        },
        model2: {
            title: 'LOTUS',
            features: [
                'Bed frame',
                'Wooden / fabric / leather headboard',
                'Headboard lighting',
                '2 pull-out cabinets',
                'Storage space under the mattress',
                'Drawers for laundry',
            ],
        },
        model3: {
            title: 'CLASSIC',
            features: [
                'Bed frame',
                'Wooden headboard',
                'Headboard lighting',
                '2 cabinets',
                'Storage space under the mattress',
            ],
        },
        model4: {
            title: 'MINIMALISM',
            features: [
                'Bed frame',
                'Wooden / fabric / leather headboard',
                'Headboard lighting',
                '2 pull-out cabinets',
                'Storage space under the mattress',
                'Drawers for laundry',
            ],
        },
        model5: {
            title: 'LOFT',
            features: [
                'Bed frame',
                'Wooden headboard',
                'Headboard lighting',
                '2 cabinets',
                'Storage space under the mattress',
            ],
        },
    },
    lotusPage: {
        title: 'The LOTUS model',
        desc: 'This finish option includes kinglets covered with golden metallic and glossy lacquer. Combined with the warm tones of the designer veneer, they create a unique look that emphasizes elegance combined with modern style and sophistication.',
        variation: 'The "Sweet Dream" finish option'
    },
    contacUs: {
        title: 'Contact us',
        mail: 'Mail:',
        phone: 'Phone:',
        msg: 'Message:',
        btnText: 'Send'
    },
    subcribe: {
        title: 'Subscribe to the newsletter and stay up to date with the news from the company NIRIVS',
        mail: 'Mail:',
        btnText: 'Subscribe to the newsletter'
    }
  };
  